import React, { useCallback } from 'react';

import { useRegisterPageContainerError } from '../../../../components/layout/page-container/page-container-error-handler';
import UsersListBig from '../../../../components/reusable/users-list/UsersListBig';
import {
  useGetRejectedUserSubscriberRequests,
  useGetUserSubscriberRequests,
} from '../../../../redux/api/users/usersApi';
import { orderBy } from '../../../../utils/collections/array-utils';

export default function MyRequests() {
  const {
    data: userSubscriberRequests,
    isError: isErrorSubscriberRequests,
    error: subscriberRequestsError,
    refetch: refetchSubscriberRequests,
  } = useGetUserSubscriberRequests();
  const {
    data: rejectedUserSubscriberRequests,
    isError: isErrorRejectedRequests,
    error: rejectedRequestsError,
    refetch: refetchRejectedRequests,
  } = useGetRejectedUserSubscriberRequests();

  const refreshRequests = useCallback(() => {
    void refetchSubscriberRequests();
    void refetchRejectedRequests();
  }, [refetchSubscriberRequests, refetchRejectedRequests]);

  function getRequests() {
    return userSubscriberRequests && rejectedUserSubscriberRequests
      ? orderBy(
          [...userSubscriberRequests, ...rejectedUserSubscriberRequests],
          ['firstname', 'lastname'],
          ['asc', 'asc'],
        )
      : null;
  }

  const mergedRequests = getRequests();
  const isListLoading =
    userSubscriberRequests === undefined ||
    rejectedUserSubscriberRequests === undefined;

  const isListError = isErrorSubscriberRequests || isErrorRejectedRequests;
  const requestErrors = [
    ...(isErrorSubscriberRequests && subscriberRequestsError
      ? [subscriberRequestsError]
      : []),
    ...(isErrorRejectedRequests && rejectedRequestsError
      ? [rejectedRequestsError]
      : []),
  ];

  useRegisterPageContainerError({
    errors: requestErrors,
    isLoading: isListLoading,
    hasData: Boolean(mergedRequests),
    onRetry: refreshRequests,
  });

  return (
    <UsersListBig
      users={mergedRequests}
      showSearch
      isLoading={isListLoading}
      isError={isListError}
    />
  );
}
